import { render, staticRenderFns } from "./DocUpload.vue?vue&type=template&id=96b1fd3e&scoped=true&"
import script from "./DocUpload.vue?vue&type=script&lang=js&"
export * from "./DocUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocUpload.vue?vue&type=style&index=0&id=96b1fd3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b1fd3e",
  null
  
)

export default component.exports